import { render, staticRenderFns } from "./CustomViews.vue?vue&type=template&id=aa7d4f68&scoped=true&"
import script from "./CustomViews.vue?vue&type=script&lang=js&"
export * from "./CustomViews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa7d4f68",
  null
  
)

export default component.exports